import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

const LayoutSelection = ({ setSelectedLayout }) => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState("layoutA"); // Default to layout B (4 photos)
  
  useEffect(() => {
    try {
      // Load AdSense ads
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  const layouts = {
    layoutA: {
      name: "Layout A",
      description: "4 Pose",
      image: "/layouts/layout-a.png",
      poses: 4
    },
    layoutB: {
      name: "Layout B",
      description: "3 Pose",
      image: "/layouts/layout-b.png", 
      poses: 3
    },
    layoutC: {
      name: "Layout C",
      description: "2 Pose",
      image: "/layouts/layout-c.png",
      poses: 2
    },
    layoutD: {
      name: "Layout D",
      description: "6 pose",
      image: "/layouts/layout-d.png",
      poses: 6
    },
    layoutE: {
      name: "Traditional Photobooth Layout",
      description: "4 Pose Vertical",
      image: "/layouts/traditional.png",
      poses: 4,
      orientation: "vertical"
}
  };

  const handleLayoutSelect = (layoutKey) => {
    setSelected(layoutKey);
  };

  const handleContinue = () => {
    // Pass the selected layout to parent component
    setSelectedLayout({
      type: selected,
      poses: layouts[selected].poses,
      orientation: layouts[selected].orientation || "horizontal"

    });
    
    // Navigate to the photo booth
    navigate("/picapica-photobooth");
  };


  return (
    <div className="layout-selection-container">
      <h1>Choose your layout</h1> 
      <p className="layout-note">Select a layout for your photo session. You can choose from different styles and poses.</p>

      <div className="layout-options" style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
        gap: "10px",
        width: "100%", 
        maxWidth: "700px", 
        margin: "0 auto" 
      }}>
        {Object.keys(layouts).map((layoutKey) => {
          const layout = layouts[layoutKey];
          return (
            <div 
              key={layoutKey}
              className={`layout-option ${selected === layoutKey ? 'selected' : ''}`}
              onClick={() => handleLayoutSelect(layoutKey)}
              style={{
                backgroundColor: "transparent",
                border: selected === layoutKey ? "3px solid #ff69b4" : "1px solid transparent",
                transition: "all 0.3s ease",
                borderRadius: "10px",
                overflow: "hidden",
                position: "relative",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                flex: "1",
                maxWidth: "22%",
                minWidth: "130px"
              }}
            >
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}>
                <div style={{
                  backgroundColor: "rgba(230, 230, 255, 0.7)",
                  padding: "8px",
                  borderRadius: "10px 10px 0 0",
                  width: "100%"
                }}>
                  <img 
                    src={layout.image} 
                    alt={layout.name} 
                    style={{
                      width: "100%", 
                      height: "auto",
                      objectFit: "contain",
                      display: "block",
                      borderRadius: "5px"
                    }}
                  />
                </div>
                <div style={{
                  backgroundColor: "white",
                  padding: "5px",
                  textAlign: "center",
                  width: "100%",
                  borderRadius: "0 0 10px 10px"
                }}>
                  <h3 style={{ margin: "0 0 5px 0", fontSize: "0.9rem" }}>{layout.name}</h3>
                  <p style={{ margin: "0", fontSize: "0.7rem", color: "#666" }}>{layout.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

        {/* Google AdSense Ad */}
        <div className="ad-container" style={{ margin: "30px auto", maxWidth: "100%" }}>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2065338109976469" crossOrigin="anonymous"></script>
        {/* layout page */}
        <ins className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-2065338109976469"
          data-ad-slot="2563599480"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div>

      <button 
        className="continue-button" 
        onClick={handleContinue}
        style={{ marginTop: "30px" }}
      >
        Continue
      </button>
    </div>
  );
};

export default LayoutSelection;